import React, { Fragment } from "react";
import Slider from "react-slick";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import "./WholesaleElectronics.scss";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

/* ================= DATA ARRAYS (IMAGES ONLY) ================= */

const laptopImages = [
  "/images/wholesale/zephyrus-g16.jpg",
  "/images/wholesale/lenovo.jpg",
  "/images/wholesale/asus-rog.jpg",
  "/images/wholesale/rog-strix-g16.jpg",
  "/images/wholesale/dell-1.jpg",
  "/images/wholesale/dell-2.jpg",
  "/images/wholesale/macbook.jpg",
  "/images/wholesale/macbook-de.jpg",
  "/images/wholesale/hp-1.jpg",
  "/images/wholesale/hp-2.jpg",
];

const gpuImages = [
  "/images/wholesale/gpu-1.jpg",
  "/images/wholesale/gpu-2.jpg",
  "/images/wholesale/gpu-3.jpg",
  "/images/wholesale/gpu-4.jpg",
  "/images/wholesale/gpu-5.jpg",
  "/images/wholesale/asus-axial.jpg",
  "/images/wholesale/gigabyte-5090.jpg",
];

const storageImages = [
  "/images/wholesale/storage-1.jpg",
  "/images/wholesale/storage-2.jpg",
  "/images/wholesale/storage-3.jpg",
  "/images/wholesale/storage-4.jpg",
  "/images/wholesale/synology-ds223.jpg",
  "/images/wholesale/terramaster-f8.jpg",
  "/images/wholesale/synology-ds925.jpg",
];

/* ================= SLIDER SETTINGS ================= */

const sliderSettings = (speed) => ({
  dots: false,
  arrows: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: speed,
  speed: 700,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 2 } },
    { breakpoint: 600, settings: { slidesToShow: 1 } },
  ],
});

/* ================= REUSABLE IMAGE SLIDER ================= */

const ImageSlider = ({ images, speed }) => (
  <Slider {...sliderSettings(speed)}>
    {images.map((img, index) => (
      <div key={index} className="slider-item">
        <div className="image-box">
          <img src={img} alt="Wholesale Product" />
        </div>
      </div>
    ))}
  </Slider>
);

/* ================= PAGE ================= */

const WholesaleElectronics = () => {
  return (
    <Fragment>
      <Navbar />

      <div className="wholesale-page">
        <h1 className="main-heading">Wholesale Supplies</h1>

        {/* LAPTOPS */}
        <section className="category">
          <h2>Laptops</h2>
          <ImageSlider images={laptopImages} speed={3500} />
        </section>

        {/* GRAPHIC CARDS */}
        <section className="category">
          <h2>Graphic Cards</h2>
          <ImageSlider images={gpuImages} speed={2800} />
        </section>

        {/* STORAGE */}
        <section className="category">
          <h2>Hard Disk & Storage</h2>
          <ImageSlider images={storageImages} speed={2200} />
        </section>

        {/* WHOLESALE INFO – UNCHANGED */}
        <section className="invoice-section">
          <h2>Wholesale Ordering, Invoicing & Payments</h2>

          <p>
            All products displayed on this page are supplied strictly on a wholesale and bulk-order basis. Global Gift Pass does not provide instant checkout
            for electronics.
          </p>

          <p>
            Each order is processed manually to ensure business verification, pricing accuracy, and compliance. Official invoices are issued prior to payment,
            and payments are accepted only through approved banking and payment channels.
          </p>

          <p>Payouts received by Global Gift Pass represent revenue generated from legitimate invoiced wholesale transactions and digital service offerings.</p>

          <h3>Wholesale Inquiry Email</h3>
          <p className="email">
            <a href="mailto:support@globalgiftpass.io">support@globalgiftpass.io</a>
          </p>

          <h4>Required Email Format</h4>
          <ul>
            <li>Company Name</li>
            <li>Contact Person</li>
            <li>Product Category (Laptop / Graphics Card / Storage)</li>
            <li>Product Model</li>
            <li>Quantity Required</li>
            <li>Delivery Country</li>
            <li>Company Website (if available)</li>
          </ul>

          <h4>Payment & Fulfillment Process</h4>
          <ol>
            <li>Wholesale inquiry received via email</li>
            <li>Business verification & order review</li>
            <li>Official invoice issued</li>
            <li>Payment completed via approved channels</li>
            <li>Order processed and dispatched via logistics partners</li>
          </ol>
        </section>
      </div>

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default WholesaleElectronics;
